// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__fnmip","img":"Logo_img__MaNoG"};